<ng-container *ngIf="dialog$ | async as dialog">
  <div class="modal-header justify-content-center">
    <div class="modal-title">Could you update Virtual Event ?</div>
  </div>
  <div class="modal-body">
    <form [formGroup]="form">
      <div>
        <mdb-form-control class="form-fill">
          <mdb-select formControlName="streamProvider" (valueChange)="updateStreamValidator($event)" class="mdb-select">
            <mdb-option *ngFor="let option of streamProviderList" [value]="option.id">{{
              option.label
            }}</mdb-option>
          </mdb-select>
          <label mdbLabel class="form-label form-label--paybee">Stream Provider</label>
          <span class="form-fill-error"  *ngIf="form.get('streamProvider').hasError('required') && form.get('streamProvider').touched ">You must make a selection</span>
        </mdb-form-control>
      </div>
      <div>
        <ng-container *ngIf="selectedProvider !== 4">
          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="streamUrl" maxLength="512" placeholder="http://paybee.io/" label='Stream Url'></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="form.get('streamUrl').hasError('required') && form.get('streamUrl').touched ">You must fill this Field</span>
          </mdb-form-control>
        </ng-container>

      </div>
      <ng-container *ngIf="event$ | async as event">
        <div *ngIf="event.goal > 0">
          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="goal" placeholder="0" label='Goal'></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="form.get('goal').hasError('required') && form.get('goal').touched ">You must fill this Field</span>
          </mdb-form-control>
        </div>
      </ng-container>
    </form>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-4 offset-4">
        <button type="button" class="btn btn--paybee btn--transparent btn--md text-center w-100" (click)="close(dialog, false)">Cancel</button>
      </div>
      <div class="col-4">
        <button type="button" class="btn btn--paybee btn--black btn--md text-center w-100" (click)="close(dialog, true)" [disabled]="form.invalid">Confirm</button>
      </div>
    </div>
  </div>
</ng-container>
